import React from "react";
import { Badge } from "reactstrap";

export default function monthlyOrderStatusBadge(status) {
    const colorMap = {
        completed: "success",
        active: "success",
        failed: "danger",
        pending: "warning",
        "on-hold": "info",
    };

    const color = colorMap[String(status).toLowerCase()] || "secondary";

    return <Badge color={color}>{status || "-"}</Badge>;
}